import type { ModelRelease } from "../types/model";
import type { OrganizationIndex } from "../lib/organizations";
import {
  developerAttributionLabel,
  developerOrganizations
} from "../lib/organizations";
import { useI18n } from "../hooks/use-i18n";

interface DeveloperAttributionProps {
  record: ModelRelease;
  organizations: OrganizationIndex;
}

export function DeveloperAttribution({
  record,
  organizations
}: DeveloperAttributionProps) {
  const { language } = useI18n();
  const developers = developerOrganizations(record, organizations);
  const label = developerAttributionLabel(record, organizations, language);

  if (!developers.length) return <span>{record.company}</span>;

  return (
    <span className="developer-attribution" title={label} aria-label={label}>
      <span className="developer-attribution__content" aria-hidden="true">
        {/* The join ends its entry rather than starting the next one, so a
            byline that wraps ends a line on the cross and starts the next one
            on a name, flush with the line above. */}
        {developers.map((organization, index) => (
          <span className="developer-attribution__entry" key={organization.id}>
            <span>{organization.names[language]}</span>
            {index < developers.length - 1 ? (
              <span className="developer-attribution__join">×</span>
            ) : null}
          </span>
        ))}
      </span>
    </span>
  );
}
